// @flow

import DrawerColumn from './drawerColumn';
import withDrawerColumnToggle from '../withDrawerColumnToggle';

export default (drawerName: string) => withDrawerColumnToggle(drawerName)(DrawerColumn);
